import React, { useState, useEffect, useRef } from 'react';
/** lib **/
import { Link } from 'react-router-dom';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

import { client } from 'api/microcms';
import { NewsItem } from 'types/myTypes';
/** components **/
import { ContentsTitle } from '../molecules';
import { FadeUp } from 'components/organisms';
/** 昆虫画像 **/
import TentouImage from 'assets/images/tentou.png';
import AntImage from 'assets/images/ant.png';
import BeeImage from 'assets/images/bee.png';
import MaimaiImage from 'assets/images/maimai.png';
import HotalImage from 'assets/images/hotal.png';
import MonshiroImage from 'assets/images/monshiro.png';
/** styles,images **/
import s from '../../styles/organisms/news.module.scss';
import classNames from 'classnames';
import dayjs from 'dayjs';

export const TopNews: React.FC = () => {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [isMobile, setIsMobile] = useState(false);

  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const animationEl = [inViewRef1];

  // タグと昆虫画像のマッピング
  const tagToInsectImage: { [key: string]: string } = {
    'お知らせ': TentouImage,
    'グループ情報': AntImage,
    '物件情報': BeeImage,
    'プレスリリース': MaimaiImage,
    'メディア情報': HotalImage,
    'イベント': MonshiroImage,
  };

  // 最新記事かどうか判定（1ヶ月以内）
  const isNew = (publishDate: string) => {
    const published = dayjs(publishDate);
    const now = dayjs();
    return now.diff(published, 'month') < 1;
  };


  useEffect(() => {
    // 画面幅の判定
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    client
      .get({
        endpoint: "news",
      })
      .then((res) => {
        setNews(res.contents)
      })
      .catch(() => {});

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(s.inview);
          } else {
            entry.target.classList.remove(s.inview);
          }
        });
      },
      {
        root: null,
        rootMargin: '-10% 0px -0% 0px',
        threshold: 0,
      },
    );
    animationEl.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      animationEl.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [animationEl]);

  return (
    <div className={s.topNewsWrapper}>
      <FadeUp delay={0}>
        <div className={s.newsContents}>
          <div className={s.newsContentsInner}>
            <div className={s.contentsTitleWrapper}>
              <ContentsTitle className={s.contentsTitle} title="お知らせ" subTitle={`P-manからのお知らせや\nペットフレンドリー物件情報`} />
              <Link className={classNames(s.moreLink, s.pcOnly)} to="/news-list">
                <p>もっとみる</p>
                <GreenCircleArrow className={s.moreLinkIcon} />
              </Link>
            </div>
            <div className={s.contentsRow}>

              <ul className={s.newsList}>
                {news.slice(0, 4).map((newsItem) => (
                  <li key={newsItem.id}>
                    {newsItem.link ?
                      // 内部リンクがある場合
                      <Link to={newsItem.link}>
                        <div className={s.text}>
                          <div className={s.date}>
                            <p>
                              {dayjs(newsItem.publishAt).format("YYYY/MM/DD")}
                              {!isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                            </p>
                            <div className={s.tagWrapper}>
                              {isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                              <span className={s.tag}>
                                {newsItem.tag[0]}
                                {tagToInsectImage[newsItem.tag[0]] && (
                                  <img className={s.insectIcon} src={tagToInsectImage[newsItem.tag[0]]} alt={newsItem.tag[0]} />
                                )}
                              </span>
                            </div>
                          </div>
                          <div className={s.title}>{newsItem.title}</div>
                        </div>
                      </Link>
                      :
                      newsItem.external_link ?
                        // 外部リンクがある場合
                        <a href={newsItem.external_link} target="_blank" rel="noreferrer">
                          <div className={s.text}>
                            <div className={s.date}>
                              <p>
                                {dayjs(newsItem.publishAt).format("YYYY/MM/DD")}
                                {!isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                              </p>
                              <div className={s.tagWrapper}>
                                {isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                                <span className={s.tag}>
                                  {newsItem.tag[0]}
                                  {tagToInsectImage[newsItem.tag[0]] && (
                                    <img className={s.insectIcon} src={tagToInsectImage[newsItem.tag[0]]} alt={newsItem.tag[0]} />
                                  )}
                                </span>
                              </div>
                            </div>

                            <div className={s.title}>{newsItem.title}</div>
                          </div>
                        </a> : newsItem.contents ?
                          // ニュース本文がある場合
                          <Link to={`/news?id=${newsItem.id}`}>
                            <div className={s.text}>
                              <div className={s.date}>
                                <p>
                                  {dayjs(newsItem.publishAt).format("YYYY/MM/DD")}
                                  {!isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                                </p>
                                <div className={s.tagWrapper}>
                                  {isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                                  <span className={s.tag}>
                                    {newsItem.tag[0]}
                                    {tagToInsectImage[newsItem.tag[0]] && (
                                      <img className={s.insectIcon} src={tagToInsectImage[newsItem.tag[0]]} alt={newsItem.tag[0]} />
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className={s.title}>{newsItem.title}</div>
                            </div>
                          </Link> :
                          // タイトルのみ
                          <div className={s.text}>
                            <div className={s.date}>
                              <p>
                                {dayjs(newsItem.publishAt).format("YYYY/MM/DD")}
                                {!isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                              </p>
                              <div className={s.tagWrapper}>
                                {isMobile && isNew(newsItem.publishAt) && <span className={s.newLabel}>NEW</span>}
                                <span className={s.tag}>
                                  {newsItem.tag[0]}
                                  {tagToInsectImage[newsItem.tag[0]] && (
                                    <img className={s.insectIcon} src={tagToInsectImage[newsItem.tag[0]]} alt={newsItem.tag[0]} />
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className={s.title}>{newsItem.title}</div>
                          </div>}
                  </li>
                ))}
              </ul>
              <Link className={classNames(s.moreLink, s.spOnly)} to="/news-list">
                <p>もっとみる</p>
                <GreenCircleArrow className={s.moreLinkIcon} />
              </Link>
            </div>
          </div>
        </div>
      </FadeUp>

    </div>
  );
};
